var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('grid-priority',{attrs:{"priority":_vm.priority,"isCombined":true}}),_c('grid-link',{attrs:{"text":_vm.text,"url":_vm.url,"isCombined":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }